export const getAuthToken = (): string | null => {
  let authorization;
  if (window.sessionStorage) authorization = window.sessionStorage.getItem("authorizationToken");

  return (authorization != null) ? authorization : null;
};

export const setAuthToken = (token: string) => {
  if (window.sessionStorage) window.sessionStorage.setItem("authorizationToken", token);
};

export const clearAuthToken = () => {
  if (window.sessionStorage) window.sessionStorage.removeItem("authorizationToken");
};

export const getQuery = () => {
  const fullPath = window.location.href;
  const p = fullPath.indexOf('?');
  const query: { [key: string]: string } = {};
  if (p >= 0) {
    const params = fullPath.substring(p + 1).split(/&/g);
    for (let i = 0; i < params.length; ++i) {
      const pp = params[i].indexOf('=');
      if (pp >= 0) {
        const key = params[i].substring(0, pp);
        const value = params[i].substring(pp + 1);
        query[key] = value;
      }
    }
  }

  return query;
}

// Keep this in lockstep with the server's MESSAGE_TYPE enum
// (server/src/components/util.ts). The subscription editor renders one
// checkbox per entry, the dashboard's "订阅消息类型分布" chart sums
// hits over these keys, and SubscriptionView's row renderer maps the
// stored numeric codes back to display labels.
export const messageTypesDict: { [key: string]: string } = {
  "60001": "私聊文本",
  "60002": "私聊图片",
  "60003": "私聊视频",
  "60004": "私聊语音",
  "60007": "私聊链接",
  "60008": "私聊文件",
  "60010": "私聊小程序",
  "60014": "私聊引用",
  "60017": "私聊视频号",
  "60018": "私聊撤回",
  "80001": "群聊文本",
  "80002": "群聊图片",
  "80003": "群聊视频",
  "80004": "群聊语音",
  "80007": "群聊链接",
  "80008": "群聊文件",
  "80010": "群聊小程序",
  "80014": "群聊引用",
  "80017": "群聊视频号",
  "80018": "群聊撤回",
}

export const ProxyArea: string[] = [
  "北京",
  "天津",
  "上海",
  "重庆",
  "河北",
  "山西",
  "江苏",
  "浙江",
  "安徽",
  "福建",
  "江西",
  "山东",
  "河南",
  "湖北",
  "湖南",
  "广东",
  "海南",
  "四川",
  "云南",
  "陕西",
  "黑龙江",
  "辽宁",
  "贵州",
  "广西",
  "宁夏",
  "青海",
  "甘肃",
  "西藏",
  "吉林",
  "内蒙",
]